if (!customElements.get('gf-shop')) customElements.define('gf-shop', class extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.events = new AbortController(); const opts = { signal: this.events.signal };
    const search = this.querySelector('[data-shop-search]'), chips = [...this.querySelectorAll('[data-category]')];
    const cards = [...this.querySelectorAll('[data-shop-card]')];
    const sortOrder = this.querySelector('[name=sort_by]').value;
    if (sortOrder === 'title-ascending' || sortOrder === 'title-descending') {
      const direction = sortOrder === 'title-ascending' ? 1 : -1;
      const grid = this.querySelector('.gf-shop-grid'), help = this.querySelector('[data-shop-help-card]');
      cards.sort((a, b) => direction * a.dataset.title.localeCompare(b.dataset.title));
      cards.forEach(card => grid.insertBefore(card, help));
    }
    const available = this.querySelector('[data-in-stock]');
    const params = new URL(location.href).searchParams;
    let category = chips.some(x => x.dataset.category === params.get('gf_group')) ? params.get('gf_group') : 'all';
    search.value = params.get('gf_search') || ''; available.checked = params.get('gf_stock') === '1';
    this.querySelectorAll('[data-enhance]').forEach(el => { el.hidden = false; });
    chips.forEach(chip => { chip.querySelector('span').textContent = chip.dataset.category === 'all' ? cards.length : cards.filter(card => card.dataset.group === chip.dataset.category).length; });
    const filter = (updateURL = true) => {
      const q = search.value.toLowerCase().trim(); let count = 0;
      cards.forEach(card => {
        const match = (category === 'all' || card.dataset.group === category) && (!available.checked || card.dataset.available === 'true') && card.dataset.search.includes(q);
        card.hidden = !match; if (match) count++;
      });
      chips.forEach(chip => chip.setAttribute('aria-pressed', String(chip.dataset.category === category)));
      this.querySelector('[data-results]').textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.querySelector('[data-reset]').hidden = category === 'all' && !q && !available.checked;
      const help = this.querySelector('[data-shop-help-card]'); if (help) help.hidden = category !== 'all' || Boolean(q) || available.checked;
      this.querySelector('[name=gf_group]').value = category;
      this.querySelector('[name=gf_search]').value = search.value.trim();
      this.querySelector('[name=gf_stock]').value = available.checked ? '1' : '';
      if (updateURL) {
        const url = new URL(location.href);
        [['gf_group',category === 'all' ? '' : category],['gf_search',search.value.trim()],['gf_stock',available.checked ? '1' : '']].forEach(([key,value]) => { if(value) url.searchParams.set(key,value); else url.searchParams.delete(key); });
        history.replaceState({}, '', url);
      }
    };
    chips.forEach(chip => chip.addEventListener('click', () => { category = chip.dataset.category; filter(); }, opts));
    search.addEventListener('input', () => filter(), opts);
    available.addEventListener('change', () => filter(), opts);
    this.querySelectorAll('[data-reset],[data-reset-empty]').forEach(button => button.addEventListener('click', () => { category = 'all'; search.value = ''; available.checked = false; filter(); search.focus(); }, opts));
    filter(false);
    this.querySelectorAll('.gf-shop-add').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault(); const button = form.querySelector('button'); if (button.disabled) return;
      const label = button.querySelector('[data-button-label]'), initial = label.textContent;
      const card = form.closest('[data-shop-card]'), status = card.querySelector('[data-card-status]');
      button.disabled = true; label.textContent = 'Adding…'; status.textContent = '';
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json(); if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
        status.textContent = 'Added to your bag.';
        const notice = this.querySelector('[data-shop-cart-notice]'); notice.hidden = false;
        notice.querySelector('[data-notice-text]').textContent = `${card.dataset.title} added to your bag.`;
        document.dispatchEvent(new CustomEvent('gf:cart-added'));
      } catch (error) { status.textContent = error.message || 'Please try again.'; }
      finally { button.disabled = false; label.textContent = initial; }
    }, opts));
    this.querySelector('[data-dismiss-notice]').addEventListener('click', () => { this.querySelector('[data-shop-cart-notice]').hidden = true; }, opts);
  }
  disconnectedCallback() { this.events?.abort(); this.events = null; }
});
